import { render, staticRenderFns } from "./TimUiMedia.vue?vue&type=template&id=2551d64e&scoped=true&"
import script from "./TimUiMedia.vue?vue&type=script&lang=js&"
export * from "./TimUiMedia.vue?vue&type=script&lang=js&"
import style0 from "./TimUiMedia.vue?vue&type=style&index=0&id=2551d64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551d64e",
  null
  
)

export default component.exports